import PropTypes from 'prop-types';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import CardBody, { resolveCardVariant } from './Body';
import { useIsEditPreview } from '../../../helpers/editPreviewContext';

const View = ({ data, className }) => {
  const variant = resolveCardVariant(data);
  const isEditPreview = useIsEditPreview();

  return (
    <div className={cx('block', 'csjCard', `csj-card--${variant}`, className)}>
      <CardBody data={data} isEditMode={isEditPreview} />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
